// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user {
  display: flex;
  gap: var(--spacing);
  align-items: flex-start;
  padding: var(--spacing) 0;
  margin-bottom: var(--spacing);
  border-bottom: 1px solid var(--ion-color-light);
}
.user img {
  width: calc(var(--spacing) * 5);
  border-radius: 50%;
  max-width: 25%;
}
.user h3 {
  margin: 0;
}
.user p:last-of-type {
  margin: 0;
}

.actions {
  display: flex;
  gap: var(--spacing);
  margin-top: var(--spacing);
  align-items: center;
  justify-content: flex-end;
}`, "",{"version":3,"sources":["webpack://./src/app/general-components/user-form/user-form.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,6BAAA;EACA,+CAAA;AACJ;AACI;EACI,+BAAA;EACA,kBAAA;EACA,cAAA;AACR;AAEI;EACI,SAAA;AAAR;AAGI;EACI,SAAA;AADR;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,yBAAA;AAHJ","sourcesContent":[".user {\n    display: flex;\n    gap: var(--spacing);\n    align-items: flex-start;\n    padding: var(--spacing) 0;\n    margin-bottom: var(--spacing);\n    border-bottom: 1px solid var(--ion-color-light);\n\n    img {\n        width: calc(var(--spacing) * 5);\n        border-radius: 50%;\n        max-width: 25%;\n    }\n\n    h3 {\n        margin: 0;\n    }\n\n    p:last-of-type {\n        margin: 0;\n    }\n}\n\n\n.actions {\n    display: flex;\n    gap: var(--spacing);\n    margin-top: var(--spacing);\n    align-items: center;\n    justify-content: flex-end;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
